import { render, staticRenderFns } from "./AllDocumentComponent.vue?vue&type=template&id=0ae88c66&scoped=true&"
import script from "./AllDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./AllDocumentComponent.vue?vue&type=script&lang=js&"
import style0 from "./AllDocumentComponent.vue?vue&type=style&index=0&id=0ae88c66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae88c66",
  null
  
)

export default component.exports